import classNames from 'classnames';
import React, { memo, MouseEvent, MouseEventHandler } from 'react';

import { TFileTheme } from '../../FileIcon.types';
import styles from '../FileIconDefault.styles.m.css';

interface IFileIconLoadingProps {
  theme: TFileTheme;
  text: string;
  onCancel?: MouseEventHandler<SVGGElement>;
}

export const FileIconLoading = memo<IFileIconLoadingProps>((props) => {
  const { theme, text, onCancel } = props;

  return (
    <>
      <path
        className={styles[`file-${theme}`]}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3H31L43 15V29.8321C41.7751 29.2969 40.4222 29 39 29C33.4772 29 29 33.4772 29 39C29 40.4222 29.2969 41.7751 29.8321 43H11C7.68629 43 5 40.3137 5 37V9C5 5.68629 7.68629 3 11 3Z"
      />
      <path
        opacity="0.2"
        d="M43 15L31 3V11C31 13.2091 32.7909 15 35 15H43Z"
        fill="black"
      />
      <g
        className={styles.pointer}
        onClick={(e: MouseEvent<SVGGElement>): void => {
          e.stopPropagation();
          onCancel?.(e);
        }}
      >
        <circle
          className={classNames(styles[`file-${theme}`])}
          cx="39"
          cy="39"
          r="9"
        />
        <circle
          className={classNames(styles.progress)}
          cx="39"
          cy="39"
          r="7"
        />
        <path
          d="M41.7174 36.228C41.4142 35.924 40.9226 35.924 40.6194 36.228L38.9805 37.8714L37.3806 36.2671C37.0774 35.9631 36.5858 35.9631 36.2826 36.2671C35.9794 36.5712 35.9794 37.0641 36.2826 37.3681L37.8825 38.9723L36.2274 40.6319C35.9242 40.9359 35.9242 41.4288 36.2274 41.7329C36.5306 42.0369 37.0222 42.0369 37.3254 41.7329L38.9805 40.0733L40.6746 41.772C40.9778 42.076 41.4694 42.076 41.7726 41.772C42.0758 41.468 42.0758 40.975 41.7726 40.671L40.0785 38.9723L41.7174 37.329C42.0206 37.025 42.0206 36.532 41.7174 36.228Z"
          fill="white"
        />
      </g>
      <text
        className={styles.text}
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
      >
        {text}
      </text>
    </>
  );
});
